"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TooltipIcon;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

var _excluded = ["title", "content"];

function InfoCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 0.25C4.16797 0.25 0.25 4.16797 0.25 9C0.25 13.832 4.16797 17.75 9 17.75C13.832 17.75 17.75 13.832 17.75 9C17.75 4.16797 13.832 0.25 9 0.25ZM9.625 13.2188C9.625 13.3047 9.55469 13.375 9.46875 13.375H8.53125C8.44531 13.375 8.375 13.3047 8.375 13.2188V7.90625C8.375 7.82031 8.44531 7.75 8.53125 7.75H9.46875C9.55469 7.75 9.625 7.82031 9.625 7.90625V13.2188ZM9 6.5C8.75467 6.49499 8.52108 6.39402 8.34935 6.21875C8.17763 6.04348 8.08144 5.80788 8.08144 5.5625C8.08144 5.31712 8.17763 5.08152 8.34935 4.90625C8.52108 4.73098 8.75467 4.63001 9 4.625C9.24533 4.63001 9.47892 4.73098 9.65065 4.90625C9.82237 5.08152 9.91856 5.31712 9.91856 5.5625C9.91856 5.80788 9.82237 6.04348 9.65065 6.21875C9.47892 6.39402 9.24533 6.49499 9 6.5Z",
    fill: "#ADADAD"
  }));
}

function TooltipIcon(_ref) {
  var title = _ref.title,
      content = _ref.content,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], (0, _extends2["default"])({
    title: title,
    content: content
  }, rest), /*#__PURE__*/_react["default"].createElement(InfoCircle, null));
}